export default __webpack_public_path__ + "static/media/list_black_icon.499315cd.svg";